import React, { useEffect } from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import PublicRoute from "./PublicRoute";
import PrivateRoute from "./PrivateRoute";
import MainLayout from "./layouts/MainLayout";
import NotFound from "./components/404";
import FarmsAndFieldsPage from "./pages/FarmsAndFields";
import GettingStartedPage from "./pages/GettingStarted";
import DashboardPage from "./pages/Dashboard";
import FarmsIndexPage from "./pages/Farms";
import PayPage from "./pages/Pay";
import OrdersPage from "./pages/Order";
import PremiumPage from "./pages/Premium";
import OrderReviewPage from "./pages/Order/OrderReview";
import StripePage from "./pages/Stripe";
import ProfileSettingsPage from "./pages/ProfileSettings";
import ProductsAndGuidesPage from "./pages/ProductsAndGuides";
import RapidEMPage from "./pages/RapidEMBooking";
import StackAnalysisPage from "./pages/StackAnalysis";
import StorePage from "./pages/Store";
import PaymentPage from "./pages/Payment";
import PaymentSuccessPage from "./pages/Payment/components/PaymentSuccessPage";
import AuthCallback from "./pages/Auth/Callback";

const Routes = () => {
  const { isAuthenticated } = useAuth0();

  useEffect(() => {
    if (!isAuthenticated && window.location.pathname !== "/auth/callback") {
      localStorage.setItem("loginRedirectPath", window.location.pathname);
    }
  }, [isAuthenticated]);

  return (
    <BrowserRouter>
      <Switch>
        <PrivateRoute
          path="/"
          component={DashboardPage}
          layout={MainLayout}
          exact
        />
        <Route path="/dashboard" component={DashboardPage} />
        <Route path="/farms" component={FarmsAndFieldsPage} />
        <Route path="/getting-started" component={GettingStartedPage} />
        <Route path="/fields" component={FarmsIndexPage} />
        <Route path="/pay" component={PayPage} />
        <Route path="/order" component={OrdersPage} />
        <Route path="/rapid-em-booking" component={RapidEMPage} />
        <Route path="/stack-analysis" component={StackAnalysisPage} />
        <Route path="/order-review/:id" component={OrderReviewPage} exact />
        <Route path="/order-review/:id/:type" component={OrderReviewPage} />
        <Route path="/stripe" component={StripePage} />
        <Route path="/advanced" component={PremiumPage} />
        <Route path="/settings" component={ProfileSettingsPage} />
        <Route path="/store" component={StorePage} />
        <Route path="/payment-success" component={PaymentSuccessPage} />
        <Route path="/products-and-guides" component={ProductsAndGuidesPage} />
        <Route path="/payment" component={PaymentPage} />
        <PrivateRoute
          path="/auth/callback"
          component={AuthCallback}
          layout={MainLayout}
        />
        <PublicRoute component={NotFound} layout={MainLayout} />
      </Switch>
    </BrowserRouter>
  );
};

export default Routes;
